import { render, staticRenderFns } from "./TermsWriteDefaultLayout.vue?vue&type=template&id=5b13626c&scoped=true&"
import script from "./TermsWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./TermsWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b13626c",
  null
  
)

export default component.exports